import { render, staticRenderFns } from "./DeliveryParse.vue?vue&type=template&id=e737e1f2"
import script from "./DeliveryParse.vue?vue&type=script&lang=ts"
export * from "./DeliveryParse.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports